import { ReactNode } from 'react';
import styled from 'styled-components';
import { titleLarge } from 'styles-js/mixins/typography';
import Mention from 'src/components/textEditor/components/mention';
import ImageEl from 'src/components/textEditor/components/image';
import { ImageElement } from 'src/components/textEditor/customTypes';
type ElementProps = {
  attributes: Record<string, string | boolean>;
  children: ReactNode;
  element: {
    align?: 'left' | 'right' | 'center';
    type: string;
  };
  imgWithDescription?: boolean;
};

// we don't use most of these atm, but it's nice as an example to see how extensible it is
// WHEN ADDING A NEW ELEMENT - all elements must have 'children', even if children are just an empty string
export const Element = ({
  attributes,
  children,
  element,
  imgWithDescription = true
}: ElementProps) => {
  const style = {
    textAlign: element?.align
  };
  switch (element.type) {
    case 'image':
      // Renamed to ImageEl, otherwise ESlint complains about missing alt tag (new since Next.js v11)
      return <ImageEl attributes={attributes} element={(element as ImageElement)} imgWithDescription={imgWithDescription}>{children}</ImageEl>;
    case 'mention':
      return <Mention attributes={attributes} element={element}>{children}</Mention>;
    case 'title-medium':
      return <StyledTitleMedium {...attributes}>{children}</StyledTitleMedium>;
    // eslint-disable-line
    // case 'block-quote':
    //   return (
    //     <blockquote style={style} {...attributes}>
    //       {children}
    //     </blockquote>
    //   );
    // case 'bulleted-list':
    //   return (
    //     <ul style={style} {...attributes}>
    //       {children}
    //     </ul>
    //   );
    // case 'heading-one':
    //   return (
    //     <h1 style={style} {...attributes}>
    //       {children}
    //     </h1>
    //   );
    // case 'heading-two':
    //   return (
    //     <h2 style={style} {...attributes}>
    //       {children}
    //     </h2>
    //   );
    // case 'list-item':
    //   return (
    //     <li style={style} {...attributes}>
    //       {children}
    //     </li>
    //   );
    default:
      // this is for new paragraph
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <p style={{
          ...style,
          margin: '0 0 15px'
        }} {...attributes}>
          {children}
        </p>
      );
  }
};
const StyledTitleMedium = styled.div`
  ${titleLarge};
  padding-right: 70px; // counter width on write post page
`;